webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_API_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_API_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SHIPPING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_SHIPPING_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLEAR_SHIPPING_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_SHIPPING_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PAYMENT_AUTHORIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PAYMENT_AUTHORIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PLACE_ORDER; });
/* unused harmony export CANCEL_ORDER */
var SET_API_STATUS = 'SET_API_STATUS';
var SET_API_ERROR = 'SET_API_ERROR';

var SET_COLOR = 'SET_COLOR';
var SET_PRODUCT = 'SET_PRODUCT';

var FETCH_CART = 'FETCH_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
var SET_SHIPPING_METHOD = 'SET_SHIPPING_METHOD';
var CLEAR_SHIPPING_METHOD = 'CLEAR_SHIPPING_METHOD';
var FETCH_SHIPPING_METHODS = 'FETCH_SHIPPING_METHODS';

var FETCH_PAYMENT_AUTHORIZATION = 'FETCH_PAYMENT_AUTHORIZATION';
var SET_PAYMENT_AUTHORIZATION = 'SET_PAYMENT_AUTHORIZATION';

var PLACE_ORDER = 'PLACE_ORDER';
var CANCEL_ORDER = 'CANCEL_ORDER';

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Order__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Review__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Review___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Review__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Confirmation__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Confirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Confirmation__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a }, { path: '/order', name: 'order', component: __WEBPACK_IMPORTED_MODULE_3__components_Order___default.a }, { path: '/review', name: 'review', component: __WEBPACK_IMPORTED_MODULE_4__components_Review___default.a }, { path: '/confirmation', name: 'confirmation', component: __WEBPACK_IMPORTED_MODULE_5__components_Confirmation___default.a }]
}));

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_main__ = __webpack_require__(131);



var _mutations, _actions;




__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */]);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */].Store({
  state: {
    api: {
      status: 'idle',
      errors: false
    },
    order: false,
    payment: {
      authorization: false
    },
    cart: {
      loaded: false,
      items: [],
      shipping: {
        address: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null
        },
        methods: [],
        method: false
      }
    },
    shop: {
      selectedColor: null,
      selectedProduct: null,
      products: [{
        id: 4,
        name: '4 Gun Mattress',
        short_name: '4 GUN',
        img: '/img/sizes/gun_size_4_GUN.svg',
        description: '28" x 48"'
      }, {
        id: 6,
        name: '6 Gun Mattress',
        short_name: '6 GUN',
        img: '/img/sizes/gun_size_6_GUN.svg',
        description: '38" x 48"'
      }, {
        id: 8,
        name: '8 Gun Mattress',
        short_name: '8 GUN',
        img: '/img/sizes/gun_size_8_GUN.svg',
        description: '48" x 48"'
      }],
      colors: [{
        id: 1,
        name: 'Black',
        full_name: 'Black',
        img: '/img/colors/color_black.png',
        fabric: 'Solution Dyed Polyester'
      }, {
        id: 2,
        name: 'Charcoal Grey',
        full_name: 'Charcoal Grey',
        img: '/img/colors/color_grey.png',
        fabric: 'Denier PVC Polyester'
      }, {
        id: 3,
        name: 'Sand Beige',
        full_name: 'Sand Beige',
        img: '/img/colors/color_tan.png',
        fabric: 'Denier PVC Polyester'
      }, {
        id: 4,
        name: 'Chocolate Brown',
        full_name: 'Chocolate Brown',
        img: '/img/colors/color_maroon.png',
        fabric: 'Denier PVC Polyester'
      },
      //{
      //    id: 5,
      //    name: 'WWII Autumn Camo',
      //    full_name: 'WWII Autumn Camo Print (limited edition)',
      //    img: '/img/colors/color_browncamo.png',
      //    fabric: 'Cordura Plus'
      //},
      {
        id: 6,
        name: 'Tan',
        full_name: 'Tan',
        img: '/img/colors/color_brown.png',
        fabric: 'Solution Dyed Polyester'
      }, {
        id: 7,
        name: 'Olive Drab Green',
        full_name: 'Olive Drab Green Cotton Duck Canvas #8',
        img: '/img/colors/color_od_green.png',
        fabric: 'Cotton Duck'
      }, {
        id: 8,
        name: 'Green Camo',
        full_name: 'Green Camo Print',
        img: '/img/colors/color_green_camo.png',
        fabric: 'Denier PVC Polyester'
      }, {
        id: 9,
        name: 'Loden Green',
        full_name: 'Loden Green',
        img: '/img/colors/color_green.png',
        fabric: 'Denier PVC Polyester'
      }, {
        id: 10,
        name: 'Bushlan® Green',
        full_name: 'Bushlan® Green',
        img: '/img/colors/bushlan_green.png',
        fabric: '1000 Denier Nylon'
      }, {
        id: 11,
        name: 'Bushlan® Brown',
        full_name: 'Bushlan® Brown',
        img: '/img/colors/bushlan_brown.png',
        fabric: '1000 Denier Nylon'
      }, {
        id: 12,
        name: 'Bushlan® Grey',
        full_name: 'Bushlan® Grey',
        img: '/img/colors/bushlan_grey.png',
        fabric: '1000 Denier Nylon'
      }],
      fabrics: [{
        name: 'Solution Dyed Polyester',
        description: 'Solution Dyed Polyester 600 Denier (urethane water repellent coating)  - Excellent strength, durability, UV and mildew resistant. Easy to clean, abrasion resistant and environmentally friendly.' + '<br/><br/> 600 Denier Solution Dyed Polyester is Marine Grade Canvas designed for unforgivable and extreme conditions. This material is commonly used to manufacture boat covers and awnings due its water and mildew resistant qualities. This versatile fabric is useful for both in and outdoor use.' + '<br/><br/> Solution dyeing is a yarn coloration process in which pigment is added to the melted polymer before the polymer’s extrusion into the fiber. The color, is an inherent part of the yarn, lending itself to be particularly suited to demanding commercial environments. Features of 100% solution dyed products include:' + '<ul><li>Impervious to spot cleaning with bleach-based solutions and other harsh chemicals.</li><li>Colorfastness</li><li>Environmentally friendly and efficient, using little water or energy.</li><li>Precise color uniformity.</li></ul>' + 'Solution dyed fabrics are one of the few fabrics that will hold their color in constant sun.'
      }, {
        name: 'Cordura Plus',
        description: 'Cordura Plus is a textured nylon for a natural spun-like appearance, with excellent resistance to abrasion, rot and mildew. Quick drying and highly water-repellent, camouflage print.' + '<br/><br/>1000D (urethane coated) <strong><em>not solution dyed</em></strong> and <strong><em>not UV resistant</em></strong>'
      }, {
        name: 'Cotton Duck',
        description: 'Cotton Duck #8 Fabric is a heavyweight, double-filled, untreated cotton material. Numbered Ducks are Double Filled, or Plied Yarn, materials which are created with a tighter weave construction and a smoother texture than single fill cotton ducks. This gives the material a stiffer hand, but makes them much hardier.' + '<br/>(usually #8 is 18 oz in weight)<br/><ul><li>100% Double Filled Cotton</li><li>High Mildew Resistance</li><li>Highly Water Resistant</li></ul>'
      }, {
        name: 'Denier PVC Polyester',
        description: 'Our 600 X 300 Denier PVC Backed Polyester is a polyester fabric with a durable 0.55mm vinyl embossed backing.  Waterproof, easy to clean, soft feel of polyester with the strength and durability of PVC'
      }, {
        name: '1000 Denier Nylon',
        description: 'Bushlan uses a PVC-backed 1000 Denier Nylon Fabric that is textured for a natural spun-like appearance, with excellent resistance to fading, abrasion, rot and mildew. Quick drying, and highly water repellent.'
      }]
    }
  },
  getters: {
    products: function products(state) {
      return state.shop.products.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    reversedProducts: function reversedProducts(state, getters) {
      return getters.products.reverse();
    },
    colors: function colors(state) {
      return state.shop.colors.map(function (color) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, color, {
          fabric: state.shop.fabrics.find(function (fabric) {
            return fabric.name === color.fabric;
          })
        });
      }).sort(function (a, b) {
        return a.id - b.id;
      });
    },
    selectedColor: function selectedColor(state) {
      return state.shop.selectedColor;
    },
    selectedProduct: function selectedProduct(state) {
      return state.shop.selectedProduct;
    },
    cartLoaded: function cartLoaded(state) {
      return state.cart.loaded;
    },
    cartItems: function cartItems(state) {
      return state.cart.items;
    },
    cartSubTotal: function cartSubTotal(state) {
      var total = 0;
      if (state.cart.items.length > 0) {
        for (var x = 0; x < state.cart.items.length; x++) {
          total += state.cart.items[x].price;
        }
      }
      return total;
    },
    cartTax: function cartTax(state, getters) {
      return (getters.shippingFilledOut && state.cart.shipping.address.state == "TX" ? getters.cartSubTotal * 0.0825 : 0) + getters.shipTotal * 0.0825;
    },
    shipTotal: function shipTotal(state) {
      return state.cart.shipping.method !== false ? state.cart.shipping.method.amount : 0;
    },
    cartTotal: function cartTotal(state, getters) {
      return getters.cartSubTotal + getters.cartTax + getters.shipTotal;
    },
    shippingAddress: function shippingAddress(state) {
      return state.cart.shipping.address;
    },
    shippingMethods: function shippingMethods(state) {
      return state.cart.shipping.methods;
    },
    sortedShippingMethods: function sortedShippingMethods(state) {
      var methods = [];
      for (var provider_name in state.cart.shipping.methods) {
        for (var method_name in state.cart.shipping.methods[provider_name]) {
          var method = state.cart.shipping.methods[provider_name][method_name];
          methods.push({
            provider: provider_name,
            name: method_name,
            amount: method.amount,
            estimate: method.estimate,
            token: method.token
          });
        }
      }

      return methods.sort(function (a, b) {
        return a.amount - b.amount;
      }).sort(function (a, b) {
        return a.estimate - b.estimate;
      });
    },
    shippingMethod: function shippingMethod(state) {
      return state.cart.shipping.method;
    },
    shippingFilledOut: function shippingFilledOut(state) {
      return state.cart.shipping.address.first_name !== null && state.cart.shipping.address.last_name !== null && state.cart.shipping.address.email !== null && state.cart.shipping.address.address1 !== null && state.cart.shipping.address.city !== null && state.cart.shipping.address.state !== null && state.cart.shipping.address.zip !== null;
    },
    order: function order(state) {
      return state.order;
    }
  },
  mutations: (_mutations = {}, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["g" /* SET_API_ERROR */]] = function (state, error) {
    state.api.errors = error;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["h" /* SET_API_STATUS */]] = function (state, status) {
    state.api.status = status;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["i" /* SET_COLOR */]] = function (state, color) {
    state.shop.selectedColor = color;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["j" /* SET_PRODUCT */]] = function (state, product) {
    state.shop.selectedProduct = product;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["a" /* FETCH_CART */]] = function (state, cart) {
    state.cart.items = cart.items;
    state.cart.shipping.address = cart.shipping.address;
    state.cart.shipping.methods = cart.shipping.methods;
    state.cart.shipping.method = cart.shipping.method;
    state.cart.loaded = true;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["f" /* ADD_TO_CART */]] = function (state, items) {
    state.cart.items = items;
    state.cart.shipping.methods = [];
    state.cart.shipping.method = false;
    state.shop.selectedColor = null;
    state.shop.selectedProduct = null;
    state.payment.authorization = false;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["c" /* REMOVE_FROM_CART */]] = function (state, id) {
    state.cart.items.splice(state.cart.items.indexOf(state.cart.items.find(function (item) {
      return item.id === id;
    })), 1);
    state.cart.shipping.methods = [];
    state.cart.shipping.method = false;
    state.payment.authorization = false;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["k" /* SET_SHIPPING_ADDRESS */]] = function (state, shipping) {
    for (var key in shipping) {
      if (shipping.hasOwnProperty(key) && state.cart.shipping.address.hasOwnProperty(key)) {
        state.cart.shipping.address[key] = shipping[key];
      }
    }
    state.cart.shipping.methods = [];
    state.cart.shipping.method = false;
    state.payment.authorization = false;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["l" /* FETCH_SHIPPING_METHODS */]] = function (state, methods) {
    state.cart.shipping.methods = methods;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["m" /* SET_SHIPPING_METHOD */]] = function (state, method) {
    state.cart.shipping.method = method;
    state.payment.authorization = false;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["n" /* CLEAR_SHIPPING_METHOD */]] = function (state) {
    state.cart.shipping.method = false;
    state.payment.authorization = false;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["b" /* FETCH_PAYMENT_AUTHORIZATION */]] = function (state, status) {
    state.payment.authorization = status;
  }, _mutations[__WEBPACK_IMPORTED_MODULE_4__types__["e" /* PLACE_ORDER */]] = function (state, order) {
    state.cart.items = [];
    state.cart.shipping.address = {
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null
    };
    state.cart.shipping.methods = [];
    state.cart.shipping.method = false;
    state.order = order;
  }, _mutations),
  actions: (_actions = {}, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["i" /* SET_COLOR */]] = function (_ref, color) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(commit(__WEBPACK_IMPORTED_MODULE_4__types__["i" /* SET_COLOR */], color));
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["j" /* SET_PRODUCT */]] = function (_ref2, product) {
    var commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(commit(__WEBPACK_IMPORTED_MODULE_4__types__["j" /* SET_PRODUCT */], product));
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["a" /* FETCH_CART */]] = function (_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["a" /* fetchCart */](commit).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* FETCH_CART */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["f" /* ADD_TO_CART */]] = function (_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state,
        getters = _ref4.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["b" /* addToCart */](commit, payload).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["f" /* ADD_TO_CART */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["c" /* REMOVE_FROM_CART */]] = function (_ref5, id) {
    var commit = _ref5.commit,
        state = _ref5.state,
        getters = _ref5.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["c" /* removeFromCart */](commit, id).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["c" /* REMOVE_FROM_CART */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["k" /* SET_SHIPPING_ADDRESS */]] = function (_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state,
        getters = _ref6.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["d" /* setShipping */](commit, payload).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["k" /* SET_SHIPPING_ADDRESS */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["l" /* FETCH_SHIPPING_METHODS */]] = function (_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state,
        getters = _ref7.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["e" /* fetchShippingMethods */](commit).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["l" /* FETCH_SHIPPING_METHODS */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["m" /* SET_SHIPPING_METHOD */]] = function (_ref8, token) {
    var commit = _ref8.commit,
        state = _ref8.state,
        getters = _ref8.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["f" /* setShippingMethod */](commit, token).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["m" /* SET_SHIPPING_METHOD */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["n" /* CLEAR_SHIPPING_METHOD */]] = function (_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state,
        getters = _ref9.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["g" /* clearShippingMethod */](commit).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["n" /* CLEAR_SHIPPING_METHOD */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["b" /* FETCH_PAYMENT_AUTHORIZATION */]] = function (_ref10) {
    var commit = _ref10.commit,
        state = _ref10.state,
        getters = _ref10.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["h" /* getAuthStatus */](commit).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["b" /* FETCH_PAYMENT_AUTHORIZATION */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["d" /* SET_PAYMENT_AUTHORIZATION */]] = function (_ref11, auth) {
    var commit = _ref11.commit,
        state = _ref11.state,
        getters = _ref11.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["i" /* setAuthStatus */](commit, auth).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["b" /* FETCH_PAYMENT_AUTHORIZATION */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions[__WEBPACK_IMPORTED_MODULE_4__types__["e" /* PLACE_ORDER */]] = function (_ref12, auth) {
    var commit = _ref12.commit,
        state = _ref12.state,
        getters = _ref12.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api_main__["j" /* placeOrder */](commit, auth).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["e" /* PLACE_ORDER */], data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }, _actions)
}));

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["host"] = host;
/* harmony export (immutable) */ __webpack_exports__["timeAgo"] = timeAgo;
/* harmony export (immutable) */ __webpack_exports__["pluralize"] = pluralize;
/* harmony export (immutable) */ __webpack_exports__["currency"] = currency;
function host(url) {
    var host = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
    var parts = host.split('.').slice(-3);
    if (parts[0] === 'www') parts.shift();
    return parts.join('.');
}

function timeAgo(time) {
    var between = Date.now() / 1000 - Number(time);
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute');
    } else if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour');
    } else {
        return pluralize(~~(between / 86400), ' day');
    }
}

function pluralize(time, label) {
    if (time === 1) {
        return time + label;
    }
    return time + label + 's';
}

function currency(value, currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    currency = currency != null ? currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = stringified.slice(0, -1 - decimals);
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = stringified.slice(-1 - decimals);
    var sign = value < 0 ? '-' : '';
    return sign + currency + head + _int.slice(i).replace(stringified, '$1,') + _float;
}

/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(217),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(223),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(218),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(215),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(221),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(220),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      loaded: false,
      cartOpen: false,
      trigger: '',
      menuOpen: false,
      menuReady: false,
      autoHideMenu: true,
      activeTransition: 'page-forward'
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['cartItems']),
  beforeMount: function beforeMount() {
    var _this = this;

    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* FETCH_CART */]).then(function (data) {
      if (_this.$store.state.cart.items.length > 0) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["b" /* FETCH_PAYMENT_AUTHORIZATION */]);
      }
      if (_this.$route.name === 'review' && _this.$store.state.cart.items.length < 1) {
        _this.$router.push({ name: 'order' });
      }
      if (_this.$route.name === 'confirmation' && _this.$store.state.order === false) {
        _this.$router.push({ name: 'order' });
      }
    });
    window.addEventListener('resize', function () {
      setTimeout(function () {
        _this.resized();
      }, 500);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.resized();
    this.loaded = true;
    setTimeout(function () {
      _this2.menuReady = true;
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    window.removeEventListener('resize', function () {
      setTimeout(function () {
        _this3.resized();
      }, 500);
    });
  },

  methods: {
    resized: function resized() {
      this.menuOpen = window.outerWidth >= 768;
      this.autoHideMenu = window.outerWidth < 768;
    },
    captureTrigger: function captureTrigger(trigger) {
      this.trigger = trigger;
    },
    routeUpdated: function routeUpdated(to, from) {
      var toDepth = to.path.split('/').length;
      var fromDepth = from.path.split('/').length;

      var transition = 'page-forward';

      if (from.name === 'home' && to.name === 'order' || from.name === 'order' && to.name === 'review') {
        transition = 'page-forward';
      } else if (from.name === 'order' && to.name === 'home') {
        transition = 'page-backward';
      } else if (from.name === 'review' && to.name === 'order' || from.name === 'review' && to.name === 'home') {
        transition = 'page-backward';
      } else {
        transition = toDepth === fromDepth ? transition : toDepth < fromDepth ? 'page-forward' : 'page-backward';
      }

      this.activeTransition = transition;
    }
  },
  watch: {
    $route: 'routeUpdated'
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ColorDisplay',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['colors', 'selectedColor']),
    methods: {
        selectColor: function selectColor(color) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["i" /* SET_COLOR */], color);
        }
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ColorSelect',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['colors', 'selectedColor']),
    methods: {
        selectColor: function selectColor(color) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["i" /* SET_COLOR */], color);
        }
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Confirmation',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['order'])
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            showScrollToTop: false,
            showAffix: false,
            affixOffset: 0,
            triggers: [],
            activeTrigger: 'what-is-it',
            scrollTolerance: 100,
            scrollTimeout: 50,
            scrollTimedOut: false
        };
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['selectedColor', 'selectedProduct', 'cartItems']),
    mounted: function mounted() {
        this.triggers = document.querySelectorAll('.affix-trigger');
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, { passive: true });
    },

    methods: {
        addToCart: function addToCart() {
            var _this = this;

            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["f" /* ADD_TO_CART */], {
                product: this.selectedProduct,
                color: this.selectedColor.name
            }).then(function (data) {
                _this.$emit('openCart');
            });
        },
        onScroll: function onScroll() {
            var scrollBounds = this.$refs.scroller.getBoundingClientRect();
            this.showScrollToTop = scrollBounds.top < 0;
            this.showAffix = this.showScrollToTop;
            this.affixOffset = scrollBounds.bottom < 360 ? Math.abs(scrollBounds.bottom - 360) : 0;

            if (this.scrollTimedOut) return; // waiting for setTimeout() to finish

            // collect dimension info on each section and put into dedicated array for easy access
            var tops = [];
            Array.prototype.forEach.call(this.triggers, function (trigger) {
                tops.push({
                    top: trigger.getBoundingClientRect().top,
                    name: trigger.getAttribute('name')
                });
            });

            // if we're not scrolled past the page title, don't calculate the active section since it should just be the first section
            if (window.scrollY < scrollBounds.top) {
                this.activeTrigger = tops[0].name;
                this.timeoutScroll();
                return;
            }

            // calculate which of the sections is currently in the viewport
            var activeTrigger = tops[0].name;
            for (var i = 0; i < tops.length; i++) {
                var trigger = tops[i];
                var previousTrigger = tops[i - 1];
                var nextTrigger = tops[i + 1];
                if (nextTrigger && previousTrigger) {
                    if (trigger.top < this.scrollTolerance && nextTrigger.top > this.scrollTolerance && previousTrigger.top < trigger.top && nextTrigger.top > trigger.top) {
                        activeTrigger = trigger.name;
                        break;
                    }
                } else if (nextTrigger && trigger.top < this.scrollTolerance && nextTrigger.top > this.scrollTolerance && trigger.top < nextTrigger.top) {
                    activeTrigger = trigger.name;
                    break;
                } else if (previousTrigger && trigger.top < this.scrollTolerance && trigger.top > previousTrigger.top) {
                    activeTrigger = trigger.name;
                    break;
                }
            }

            this.activeTrigger = activeTrigger;
            this.$emit('triggered', activeTrigger);
            this.timeoutScroll();
        },
        timeoutScroll: function timeoutScroll() {
            this.scrollTimedOut = true;
            setTimeout(function () {
                this.scrollTimedOut = false;
            }.bind(this), this.scrollTimeout);
        },
        scrollToTop: function scrollToTop() {
            this.$refs.scroller.scrollIntoView();
        }
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icons',
    props: ['icon']
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ImageSlider',
    props: ['images'],
    data: function data() {
        return {
            elements: [],
            current: 0,
            width: 0,
            changeRate: 2000,
            changeInterval: 0,
            resetTimeout: 0
        };
    },
    computed: {
        currentOffset: function currentOffset() {
            var offset = 0;
            for (var x = 0; x < this.current; x++) {
                offset += this.elements[x].clientWidth;
            }
            return -offset;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.getSizing();
        this.changeInterval = setInterval(function () {
            _this.next();
        }, this.changeRate);
        window.addEventListener('resize', function () {
            setTimeout(function () {
                _this.getSizing();
            }, 250);
        });
    },
    beforeDestroy: function beforeDestroy() {
        var _this2 = this;

        window.removeEventListener('resize', function () {
            setTimeout(function () {
                _this2.getSizing();
            }, 250);
        });
    },

    methods: {
        next: function next() {
            var _this3 = this;

            var set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            clearInterval(this.changeInterval);
            clearTimeout(this.resetTimeout);
            if (set !== null) {
                this.current = set;
            } else {
                if (this.current === this.images.length - 1) {
                    this.current = 0;
                } else {
                    this.current++;
                }
            }
            this.resetTimeout = setTimeout(function () {
                _this3.changeInterval = setInterval(function () {
                    _this3.next();
                }, _this3.changeRate);
            }, this.changeRate * 2);
        },
        prev: function prev() {
            var _this4 = this;

            var set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            clearInterval(this.changeInterval);
            clearTimeout(this.resetTimeout);
            if (set !== null) {
                this.current = set;
            } else {
                if (this.current === 0) {
                    this.current = this.images.length - 1;
                } else {
                    this.current--;
                }
            }
            this.resetTimeout = setTimeout(function () {
                _this4.changeInterval = setInterval(function () {
                    _this4.next();
                }, _this4.changeRate);
            }, this.changeRate * 2);
        },
        getSizing: function getSizing() {
            this.elements = this.$el.querySelectorAll('img');
            this.width = this.$el.clientWidth;
            this.$forceUpdate();
        }
    }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loader',
    props: ['loader']
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Order',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['selectedColor', 'selectedProduct', 'cartItems']),
    methods: {
        addToCart: function addToCart() {
            var _this = this;

            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["f" /* ADD_TO_CART */], {
                product: this.selectedProduct,
                color: this.selectedColor.name
            }).then(function (data) {
                _this.$emit('openCart');
            });
        },
        removeFromCart: function removeFromCart(id) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["c" /* REMOVE_FROM_CART */], id);
        }
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shortid__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_paypal_checkout__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_paypal_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_paypal_checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(2);

//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'advanced-paypal',
  data: function data() {
    var id = __WEBPACK_IMPORTED_MODULE_1_shortid___default.a.generate();
    return { id: id };
  },
  props: {
    createPayment: {
      type: Function,
      required: true
    },
    authorizedPayment: {
      type: Function,
      required: true
    },
    dev: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    env: function env() {
      var env = "production";
      if (this.dev) {
        return 'sandbox';
      }
      return env !== 'production' ? 'sandbox' : 'production';
    }
  },
  methods: {
    PayPalPayment: function PayPalPayment() {
      var vue = this;
      var method = this.createPayment();
      return method.then(function (data) {
        if (data.hasOwnProperty('paymentId')) {
          vue.$emit('paypal-paymentCreated', data);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data.paymentId);
        } else {
          var err = new Error('no paymentId found');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        }
      }).catch(function (err) {
        vue.$emit('paypal-paymentFailed', err);
      });
    }
  },
  mounted: function mounted() {
    var vue = this;
    var sandbox = vue.dev;
    __WEBPACK_IMPORTED_MODULE_2_paypal_checkout___default.a.Button.render({
      style: { size: 'responsive' },
      env: vue.env,
      commit: false,
      payment: function payment(resolve, reject) {
        vue.createPayment().then(function (response) {
          var data = response.data;
          if (sandbox) console.log('The payment was created!');
          vue.$emit('paypal-paymentCreated', data);
          resolve(data.paymentID);
        }, function (err) {
          reject(err);
        });
      },
      // Pass a function to be called when the customer completes the payment
      onAuthorize: function onAuthorize(data) {
        vue.$emit('paypal-paymentAuthorized', data);
        if (sandbox) console.log('The payment was authorized!');
        vue.authorizedPayment(data).then(function (data) {
          if (sandbox) console.log('The payment authorization was saved!');
          vue.$emit('paypal-paymentAuthSaved', data);
        });
      },
      // Pass a function to be called when the customer cancels the payment
      onCancel: function onCancel(data) {
        if (sandbox) console.log('The payment was cancelled!');
        vue.$emit('paypal-paymentCancelled', data);
      }
    }, vue.id);
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PopupCart',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['cartItems']),
    methods: {
        goToReview: function goToReview() {
            this.cartOpen = false;
            this.$router.push({ name: 'review' });
        },
        removeFromCart: function removeFromCart(id) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["c" /* REMOVE_FROM_CART */], id);
        }
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductDisplay',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['selectedProduct', 'reversedProducts']),
    methods: {
        selectProduct: function selectProduct(product) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["j" /* SET_PRODUCT */], product);
        }
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductSelect',
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['selectedProduct', 'reversedProducts']),
    methods: {
        selectProduct: function selectProduct(product) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["j" /* SET_PRODUCT */], product);
        }
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Review',
    data: function data() {
        return {
            editingShipping: false,
            submittingOrder: false,
            paypalDev: typeof window !== 'undefined' ? window.location.href.indexOf('.com') == -1 : true
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['cartLoaded', 'cartItems', 'cartSubTotal', 'cartTotal', 'cartTax', 'shipTotal', 'shippingAddress', 'shippingMethod', 'shippingFilledOut']),
    methods: {
        removeFromCart: function removeFromCart(id) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_types__["c" /* REMOVE_FROM_CART */], id);
        },
        createPayment: function createPayment() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/pp/create', { timeout: 15000 }).then(function (response) {
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        authorizedPayment: function authorizedPayment(authorization) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_types__["d" /* SET_PAYMENT_AUTHORIZATION */], authorization);
        },
        executePayment: function executePayment() {
            var _this = this;

            this.submittingOrder = true;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_types__["e" /* PLACE_ORDER */]).then(function (data) {
                _this.$router.push({ name: 'confirmation' });
            }).catch(function (error) {
                _this.submittingOrder = false;
            });
        }
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_us_states__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_forms__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShippingForm',
    data: function data() {
        return {
            states: __WEBPACK_IMPORTED_MODULE_0__utils_us_states__["a" /* default */],
            shipping: new __WEBPACK_IMPORTED_MODULE_1_vuex_forms__["Form"](this, this.$store.state.cart.shipping.address, {
                vuexAction: __WEBPACK_IMPORTED_MODULE_3__store_types__["k" /* SET_SHIPPING_ADDRESS */],
                validations: {
                    first_name: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"] },
                    last_name: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"] },
                    email: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["email"] },
                    address1: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"] },
                    city: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"] },
                    state: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"] },
                    zip: { required: __WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_forms_lib_validators__["minLength"])(5) }
                }
            })
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            this.shipping.submit().then(function (data) {
                _this.$emit('saved');
            });
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShippingOptions',
    data: function data() {
        return {
            loading: false
        };
    },
    mounted: function mounted() {
        if (this.$store.state.cart.shipping.method === false) {
            this.loadMethods();
        }
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['shippingMethod', 'sortedShippingMethods', 'shippingMethods', 'cartItems']),
    methods: {
        loadMethods: function loadMethods() {
            var _this = this;

            if (this.cartItems.length < 1) {
                this.$router.push({ name: 'order' });
                return;
            }
            this.loading = true;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["l" /* FETCH_SHIPPING_METHODS */]).then(function (data) {
                _this.loading = false;
            }).catch(function (data) {
                _this.loading = false;
            });
        },
        setOption: function setOption(token) {
            var _this2 = this;

            this.loading = true;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["m" /* SET_SHIPPING_METHOD */], token).then(function (data) {
                _this2.loading = false;
            }).catch(function (data) {
                _this2.loading = false;
            });
        },
        clearOption: function clearOption() {
            var _this3 = this;

            this.loading = true;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_types__["n" /* CLEAR_SHIPPING_METHOD */]).then(function (data) {
                if (_this3.$store.state.shipping.methods.length < 1) {
                    _this3.loadMethods();
                } else {
                    _this3.loading = false;
                }
            }).catch(function (data) {
                _this3.loading = false;
            });
        }
    },
    watch: {
        '$store.state.cart.items': 'loadMethods'
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_select__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FormSelect',
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_select___default()()]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FormText',
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text___default()()]
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_forms__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_filters__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Icons_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Icons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Icons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loaders_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loaders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Loaders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PopupCart_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PopupCart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_PopupCart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ImageSlider_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ImageSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ImageSlider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ColorDisplay_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ColorDisplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ColorDisplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductDisplay_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductDisplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ProductDisplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ColorSelect_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ColorSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ColorSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ProductSelect_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ProductSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ProductSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_forms_FormText_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_forms_FormText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_forms_FormText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_forms_FormSelect_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_forms_FormSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_forms_FormSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ShippingForm_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ShippingForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_ShippingForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ShippingOptions_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ShippingOptions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_ShippingOptions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Paypal_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Paypal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Paypal_vue__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex_forms___default.a);


__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__utils_filters__).forEach(function (key, index) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_7__utils_filters__[key]);
});









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('icons', __WEBPACK_IMPORTED_MODULE_8__components_Icons_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('loaders', __WEBPACK_IMPORTED_MODULE_9__components_Loaders_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('paypal', __WEBPACK_IMPORTED_MODULE_20__components_Paypal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('popup-cart', __WEBPACK_IMPORTED_MODULE_10__components_PopupCart_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('image-slider', __WEBPACK_IMPORTED_MODULE_11__components_ImageSlider_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('color-display', __WEBPACK_IMPORTED_MODULE_12__components_ColorDisplay_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('product-display', __WEBPACK_IMPORTED_MODULE_13__components_ProductDisplay_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('color-select', __WEBPACK_IMPORTED_MODULE_14__components_ColorSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('product-select', __WEBPACK_IMPORTED_MODULE_15__components_ProductSelect_vue___default.a);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('paypal', __WEBPACK_IMPORTED_MODULE_20__components_Paypal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('form-text', __WEBPACK_IMPORTED_MODULE_16__components_forms_FormText_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('form-select', __WEBPACK_IMPORTED_MODULE_17__components_forms_FormSelect_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('shipping-form', __WEBPACK_IMPORTED_MODULE_18__components_ShippingForm_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('shipping-options', __WEBPACK_IMPORTED_MODULE_19__components_ShippingOptions_vue___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export api */
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* unused harmony export methods */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(2);


// this is aliased in webpack config based on server/client build



var logRequests = false;

var apiTimeout = 10000;

var api = {
    handler: __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
        baseURL: '/api',
        timeout: apiTimeout,
        responseType: 'json'
    }),
    context: 'client'
};

function request(commit, route) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'get';

    // access the requested HTTP method to be executed
    var execute = methods[method.toLowerCase()];

    // reject for an invalid method
    if (typeof execute !== 'function') {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            logRequests && console.log('Invalid HTTP method');
            return reject();
        });
    }

    // enables or disables response caching (default: enabled)
    // for the 'GET' method only, responses are cached on the originating machine (server or browser)
    // to disable caching for a GET request, pass a false boolean as the 'data' argument
    if (method === 'get' && data === null) data = true;

    logRequests && console.log('api ' + method.toUpperCase() + ' to ' + route + (method === 'get' && data ? ' (cache requested)' : ''));

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // set the API_BUSY flag to true, indicating a request is in progress
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["h" /* SET_API_STATUS */], 'busy');

        // start a timeout to disable the busy flag for requests that take longer than the specified timeout
        var timeout = setTimeout(function () {
            console.log('API timed out');
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["h" /* SET_API_STATUS */], 'idle');
        }, apiTimeout);

        // finally execute the method
        // on success clear the API_ERROR and API_BUSY flag
        // on failure clear only the API_BUSY flag.
        // for both clear the API timeout.
        return execute(route, data).then(function (responseData) {
            clearTimeout(timeout);
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["h" /* SET_API_STATUS */], 'idle');
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["g" /* SET_API_ERROR */], false);
            resolve(responseData);
        }).catch(function (error) {
            clearTimeout(timeout);
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["h" /* SET_API_STATUS */], 'idle');
            commit(__WEBPACK_IMPORTED_MODULE_3__types__["g" /* SET_API_ERROR */], {
                code: error.response ? error.response.status : 'whammo',
                message: error.message
            });
            reject(error);
        });
    });
}

var methods = {
    get: function get(url) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var cache = api.cachedData;
        if (useCache && cache && cache.has(url)) {
            logRequests && console.log('api cache response');
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(cache.get(url));
        }

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.handler.get(url).then(function (response) {
                var val = response.data;
                // mark the timestamp when this item is cached
                if ((typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val)) === 'object') val.__lastUpdated = Date.now();
                cache && cache.set(url, val);
                resolve(val);
            }).catch(function (errors) {
                reject(errors);
            });
        });
    },
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            api.handler.post(url, data).then(function (response) {
                resolve(response.data);
            }).catch(function (errors) {
                reject(errors);
            });
        });
    }
};

/* unused harmony default export */ var _unused_webpack_default_export = (request);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCart;
/* harmony export (immutable) */ __webpack_exports__["b"] = addToCart;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeFromCart;
/* harmony export (immutable) */ __webpack_exports__["d"] = setShipping;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchShippingMethods;
/* harmony export (immutable) */ __webpack_exports__["f"] = setShippingMethod;
/* harmony export (immutable) */ __webpack_exports__["g"] = clearShippingMethod;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAuthStatus;
/* harmony export (immutable) */ __webpack_exports__["i"] = setAuthStatus;
/* harmony export (immutable) */ __webpack_exports__["j"] = placeOrder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(130);


function fetchCart(commit) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/cart', false);
}

function addToCart(commit, payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/cart/add', payload, 'post');
}

function removeFromCart(commit, id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/cart/remove', { id: id }, 'post');
}

function setShipping(commit, payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/shipping/set-address', payload, 'post');
}

function fetchShippingMethods(commit) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/shipping/methods', false);
}

function setShippingMethod(commit, token) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/shipping/set-method', { token: token }, 'post');
}

function clearShippingMethod(commit) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/shipping/clear-method');
}

function getAuthStatus(commit) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/pp/getAuth');
}

function setAuthStatus(commit, auth) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/pp/authorized', auth, 'post');
}

function placeOrder(commit, auth) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0____["a" /* request */])(commit, '/pp/execute', auth, 'post');
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MH: 'Marshall Islands',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    MP: 'Northern Marianas Islands',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PW: 'Palau',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VI: 'Virgin Islands',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
});

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label :for=\"id\">\r\n        <input ref=\"input\"\r\n               :id=\"id\"\r\n               :name=\"name\"\r\n               type=\"checkbox\"\r\n               :value=\"value\"\r\n               :checked=\"value === trueValue\"\r\n               :required=\"required\"\r\n               @change=\"handleCheckbox\"\r\n               class=\"form-control\">\r\n        {{ label }}\r\n    </label>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-html=\"label\"></label>\r\n    <label v-for=\"option in options\" :for=\"(id || name) + option[option_name]\">\r\n        <input type=\"radio\"\r\n               :name=\"name\"\r\n               :id=\"(id || name) + option[option_name]\"\r\n               :value=\"option[option_value]\"\r\n               :checked=\"value === option[option_value]\"\r\n               @change=\"handleRadio\"\r\n               class=\"form-control\">\r\n        {{ option[option_name] }}\r\n    </label>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-if=\"label\" :for=\"id\" v-html=\"label\"></label>\r\n\r\n    <select :id=\"id\"\r\n            :name=\"name\"\r\n            :multiple=\"multiple\"\r\n            :disabled=\"disabled\"\r\n            :required=\"required\"\r\n            @change=\"handleInput\"\r\n            @blur=\"handleBlur\"\r\n            @focus=\"handleFocus\"\r\n            class=\"form-control\">\r\n        <option v-for=\"option in options\" :value=\"option[option_value]\" v-text=\"option[option_name]\"\r\n                :selected=\"checkSelected(option[option_value])\"></option>\r\n    </select>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-if=\"label\" :for=\"id\" v-html=\"label\"></label>\r\n\r\n    <textarea v-if=\"type === 'textarea'\"\r\n              ref=\"input\"\r\n              :id=\"id\"\r\n              :name=\"name\"\r\n              v-model=\"value\"\r\n              :placeholder=\"placeholder\"\r\n              :required=\"required\"\r\n              @input=\"handleInput\"\r\n              @keydown=\"handleKeyDown\"\r\n              @blur=\"handleBlur\"\r\n              @focus=\"handleFocus\"\r\n              class=\"form-control\"></textarea>\r\n\r\n    <input v-if=\"type !== 'textarea'\"\r\n           ref=\"input\"\r\n           :id=\"id\"\r\n           :name=\"name\"\r\n           :type=\"type\"\r\n           :value=\"value\"\r\n           :placeholder=\"placeholder\"\r\n           :required=\"required\"\r\n           :disabled=\"disabled\"\r\n           @input=\"handleInput\"\r\n           @keydown=\"handleKeyDown\"\r\n           @blur=\"handleBlur\"\r\n           @focus=\"handleFocus\"\r\n           class=\"form-control\">\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"(error, index) in fieldErrors\" :key=\"index\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(212),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(214),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(216),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [(_vm.icon === 'search') ? _c('svg', {
    staticClass: "svg-icon icon-search",
    attrs: {
      "version": "1.1",
      "id": "icon-search",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "25 25 20 20",
      "enable-background": "new 25 25 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M37.201,26.779c3.318,0,6.02,2.701,6.02,6.021c0,3.318-2.701,6.022-6.02,6.022c-3.32,0-6.02-2.704-6.02-6.022\n            C31.181,29.48,33.881,26.779,37.201,26.779 M37.201,25.274c-4.157,0-7.526,3.369-7.526,7.525c0,4.156,3.369,7.526,7.526,7.526\n            c4.155,0,7.525-3.37,7.525-7.526C44.727,28.643,41.356,25.274,37.201,25.274L37.201,25.274z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.597,37.404c0.366,0.367,0.366,0.964,0,1.33l-5.765,5.764c-0.367,0.368-0.963,0.368-1.331,0l0,0\n            c-0.367-0.367-0.367-0.962,0-1.329l5.765-5.765C31.633,37.037,32.229,37.037,32.597,37.404L32.597,37.404z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'cart') ? _c('svg', {
    staticClass: "svg-icon icon-cart",
    attrs: {
      "version": "1.1",
      "id": "icon-cart",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "1,2 1,3 2.132,3 5.585,16 18,16 18,15 6.661,15 5.896,12 16.397,12 19.313,4 3.854,4 2.896,2 "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "5.415",
      "cy": "18.5",
      "r": "1.019"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17.058",
      "cy": "18.5",
      "r": "1.019"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'close') ? _c('svg', {
    staticClass: "svg-icon icon-close",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.071,2.929c0.391,0.391,0.391,1.023,0,1.415L4.343,17.071c-0.391,0.391-1.024,0.391-1.415,0l0,0\n        c-0.39-0.391-0.39-1.024,0-1.414L15.657,2.929C16.048,2.538,16.681,2.539,17.071,2.929L17.071,2.929z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.071,15.657c0.391,0.391,0.391,1.023,0,1.414l0,0c-0.391,0.391-1.023,0.391-1.414,0L2.929,4.343\n        c-0.39-0.391-0.39-1.024,0-1.415l0,0c0.391-0.39,1.024-0.39,1.415,0L17.071,15.657z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'chevron-right') ? _c('svg', {
    staticClass: "svg-icon icon-chevron-right",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264\n        l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21\n        S15.36,9.763,15,10.123z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon === 'chevron-left') ? _c('svg', {
    staticClass: "svg-icon icon-chevron-left",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264\n        l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21\n        S15.36,9.763,15,10.123z"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "color-container"
  }, [_c('div', {
    class: {
      'color-select': true, 'select-active': _vm.selectedColor !== null
    }
  }, _vm._l((_vm.colors), function(color) {
    return _c('div', {
      class: {
        'color-option hoverable': true, 'selected': _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor === color ? _vm.selectColor(null) : _vm.selectColor(color)
        }
      }
    }, [_c('span', {
      staticClass: "color-name"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": color.img
      }
    })])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [(_vm.loader === 'rolling') ? _c('svg', {
    staticClass: "svg-loader loader-rolling",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid",
      "width": "200px",
      "height": "200px"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "fill": "none",
      "stroke": "#FFF",
      "stroke-width": "5",
      "r": "35",
      "stroke-dasharray": "150 50",
      "transform": "rotate(114 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "calcMode": "linear",
      "values": "0 50 50;360 50 50",
      "keyTimes": "0;1",
      "dur": "1s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "top"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-down",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-image gun-mat-lander"
  }, [_c('img', {
    attrs: {
      "src": "/img/4gun_showcase.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('h1', {
    staticClass: "hero-title landing-title"
  }, [_vm._v("The Gun Mattress")]), _vm._v(" "), _c('p', {
    staticClass: "hero-tag"
  }, [_c('em', [_vm._v("Protecting your firearms for over 30 years")])])]), _vm._v(" "), (_vm.cartItems.length > 0) ? _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'review'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Checkout\n                "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : _c('router-link', {
    staticClass: "button btn-primary order-now",
    attrs: {
      "to": {
        name: 'order'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Order yours now\n                "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "main"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "what-is-it"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-section thirds"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "two-third-image"
  }, [_c('image-slider', {
    attrs: {
      "images": [
        '/img/4gun_open.png',
        '/img/4gun_half.png',
        '/img/4gun_closed.png'
      ]
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "fabric"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "hardware"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-section halves"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "half-image"
  }, [_c('image-slider', {
    attrs: {
      "images": [
        '/img/grommets.png',
        '/img/snaps_top.png',
        '/img/snaps_bottom.png'
      ]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "sizes"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Three Sizes")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('product-display'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "colors"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Eleven Colors")]), _vm._v(" "), _c('color-display'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.selectedProduct !== null && _vm.selectedColor !== null) ? _c('button', {
    staticClass: "button btn-success",
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v("\n                    Add to cart\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : (_vm.cartItems.length > 0) ? _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'review'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                    Checkout\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1) : _c('router-link', {
    staticClass: "button btn-primary",
    attrs: {
      "to": {
        name: 'order'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                    Order yours now\n                    "), _c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-third-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("What is it?")]), _vm._v(" "), _c('p', [_vm._v("\n                    Secure this one of a kind mattress to the hood or roof of any vehicle for quick and easy access\n                    to your rifles and shotguns. Your guns are hugged in the grooves of the Gun Mattress and can be\n                    sheltered in a snap with the protective cover flap - the flap is able to be completely\n                    closed and securely snapped shut in the case of rainy, dusty, or muddy conditions.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Designed to keep your guns at arms reach, without sacrificing protection, the 4.5 inches of\n                    dense padding provides superior protection for your firearms,\n                    whether on the trail or out in the field.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Whether you own a truck, Jeep, Side-by-Side ATV, or a custom hunting rig - the gun mattress is\n                    designed to fit on the hood, roof, or in the bed of nearly any vehicle you may own.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Securing it is a cinch. The heavy-duty metal grommets we place around the perimeter of\n                    the mattress allow for versatile and secure placement options through the use of rope or\n                    bungee cord (not included).\n                    Before you buy, please see the "), _c('a', {
    staticStyle: {
      "color": "#46b8da"
    },
    attrs: {
      "href": "#sizes"
    }
  }, [_vm._v("diagrams")]), _vm._v(" for sizes and actual measurements.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/4gun_jeep.jpg",
      "height": "300"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/6gun_jeep.jpg",
      "height": "300"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-height": "35vh"
    },
    attrs: {
      "src": "/img/8gun_jeep.jpg",
      "height": "300"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-section halves reversed with-border"
  }, [_c('div', {
    staticClass: "half-image"
  }, [_c('img', {
    attrs: {
      "src": "/img/4gun_standing.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "half-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("Heavy Duty Material")]), _vm._v(" "), _c('p', [_vm._v("\n                    All of our materials are hand selected for their strength and durability.\n                    They are also water and mildew and abrasion resistant, quick-drying and easy to clean!\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Recommended care and cleaning instructions:")]), _vm._v(" "), _c('br'), _vm._v("\n                    We recommend storing your mattress in a dry area, away from constant sun exposure.\n                    While these materials are durable, and some UV resistant, we want you to enjoy your\n                    product for many hunting seasons to come.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Spot clean with water on a damp sponge or cloth. If necessary, a mild soap may be used\n                    (DO NOT USE CHLORINE BLEACH). If the mattress should become wet or soaked, please allow\n                    it to dry completely in a well ventilated area before storing.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-content"
  }, [_c('h2', {
    staticClass: "hero-title"
  }, [_vm._v("Durable Hardware")]), _vm._v(" "), _c('p', [_vm._v("\n                    We stamp metal snaps into the top and flap to allow for worry-free protection\n                    of your armament in dusty or rainy conditions. The grommets you'll find around\n                    the perimeter of the gun mattress allow for easy mounting to almost any vehicle.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Our grommets and snaps are made to withstand the most difficult of environments\n                    - constructed of heavy-duty brass coated with black-oxide, they're designed\n                    to provide the ultimate in hole-reinforcement technology. Not only will you not\n                    have to worry  about tears in the fabric, the unique finish of this black-oxide\n                    hardware adds an unmistakably rugged look to your gun mattress.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_c('small', [_c('em', [_vm._v("Click to see dimensions")])])])
}]}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$route.name === 'review') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'order'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Back\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'order') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'home'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Back\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'confirmation') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'home'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Home\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'home' && _vm.menuReady) ? _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": function($event) {
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-down"
    }
  }, [(_vm.menuOpen && _vm.autoHideMenu || !_vm.autoHideMenu) ? _c('ul', [_c('li', {
    class: {
      'active': _vm.trigger === 'what-is-it'
    }
  }, [_c('a', {
    attrs: {
      "href": "#what-is-it"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("What is it?")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'fabric'
    }
  }, [_c('a', {
    attrs: {
      "href": "#fabric"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Fabric")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'hardware'
    }
  }, [_c('a', {
    attrs: {
      "href": "#hardware"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Hardware")])]), _c('li', {
    class: {
      'active': _vm.trigger === 'sizes'
    }
  }, [_c('a', {
    attrs: {
      "href": "#sizes"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Sizes")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'colors'
    }
  }, [_c('a', {
    attrs: {
      "href": "#colors"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Colors")])])]) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$route.name !== 'review' && _vm.$route.name !== 'confirmation') ? _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    class: {
      'cart-icon': true, 'open': _vm.cartOpen
    },
    on: {
      "click": function($event) {
        _vm.cartOpen = !_vm.cartOpen
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "cart"
    }
  }), _vm._v("\n                CART "), (_vm.cartItems.length > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.cartItems.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'cart-menu': true, 'open': _vm.cartOpen
    }
  }, [_c('popup-cart', {
    on: {
      "hideCart": function($event) {
        _vm.cartOpen = false
      }
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = _vm.cartOpen = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.activeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    on: {
      "triggered": _vm.captureTrigger,
      "openCart": function($event) {
        _vm.cartOpen = true
      },
      "closeCart": function($event) {
        _vm.cartOpen = false
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/img/hilsport.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                All Rights Reserved\n                "), _c('br'), _vm._v("\n                Copyright © 2020\n                "), _c('br'), _vm._v("\n                Made in USA\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/nBsFnS5sxVG2",
      "target": "_blank"
    }
  }, [_vm._v("\n                    25691 Altas Palmas Rd\n                    "), _c('br'), _vm._v("\n                    Harlingen, TX 78552\n                ")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Get in touch")]), _vm._v(" "), _c('br'), _vm._v("\n                Call "), _c('strong', [_c('a', {
    attrs: {
      "href": "tel:18004519236"
    }
  }, [_vm._v("1 (800) 451-9236")])]), _vm._v(" "), _c('br'), _vm._v("\n                       "), _c('strong', [_c('a', {
    attrs: {
      "href": "tel:19564231885"
    }
  }, [_vm._v("1 (956) 423-1885")])]), _vm._v(" "), _c('br'), _vm._v("\n                Email "), _c('strong', [_c('a', {
    attrs: {
      "href": "mailto:service@hilsport.com"
    }
  }, [_vm._v("service@hilsport.com")])])])])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "order-box"
  }, [_c('div', {
    staticClass: "order-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "sizes"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Choose a size")]), _vm._v(" "), _c('product-select')], 1), _vm._v(" "), _c('div', {
    staticClass: "order-section color-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "colors"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("Choose a color")]), _vm._v(" "), _c('color-select')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.selectedProduct !== null && _vm.selectedColor !== null) ? _c('button', {
    staticClass: "button btn-success",
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v("\n                Add to cart\n            ")]) : _c('button', {
    staticClass: "button"
  }, [_vm._v("\n                Select a\n                "), (_vm.selectedProduct === null) ? _c('span', [_vm._v("size")]) : _vm._e(), _vm._v(" "), (_vm.selectedProduct === null && _vm.selectedColor === null) ? _c('span', [_vm._v("and")]) : _vm._e(), _vm._v(" "), (_vm.selectedColor === null) ? _c('span', [_vm._v("color")]) : _vm._e()]), _vm._v(" "), (_vm.cartItems.length > 0) ? _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cart-listing",
    staticStyle: {
      "display": "inline-block",
      "max-width": "700px"
    }
  }, _vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                            " + _vm._s(item.name) + " -\n                            " + _vm._s(item.description) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                            $" + _vm._s(item.price) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "button btn-sm btn-primary",
    attrs: {
      "tag": "button",
      "to": {
        name: 'review'
      }
    }
  }, [_vm._v("\n                    Checkout\n                ")])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("\n        Customize your"), _c('br'), _vm._v("Gun Mattress\n    ")])
}]}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shipping-form container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column half"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:first_name",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "first_name"
    }],
    attrs: {
      "label": "First name",
      "id": "first_name",
      "name": "first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column half"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:last_name",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "last_name"
    }],
    attrs: {
      "label": "Last name",
      "id": "last_name",
      "name": "last_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:email",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "email"
    }],
    attrs: {
      "label": "Email",
      "type": "email",
      "id": "email",
      "name": "email"
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:phone",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "phone"
    }],
    attrs: {
      "label": "Phone (optional)",
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "mask": "(###) ###-####",
      "save-mask": false
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:address1",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "address1"
    }],
    attrs: {
      "label": "Street Address",
      "id": "address1",
      "name": "address1"
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:address2",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "address2"
    }],
    attrs: {
      "label": "Address Line 2",
      "id": "address2",
      "name": "address2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:city",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "city"
    }],
    attrs: {
      "label": "City",
      "id": "city",
      "name": "city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('form-select', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:state",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "state"
    }],
    attrs: {
      "label": "State",
      "id": "state",
      "name": "state",
      "options": _vm.states
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:zip",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "zip"
    }],
    attrs: {
      "label": "Zip",
      "id": "zip",
      "name": "zip",
      "mask": "#####-####"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n            Save\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.submittingOrder) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "loading-overlay-text"
  }, [_vm._v("\n                Submitting your order...\n                "), _c('loaders', {
    attrs: {
      "loader": "rolling"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('h1', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("\n        Checkout\n    ")]), _vm._v(" "), (_vm.cartLoaded === true) ? _c('div', {
    staticClass: "review-boxes"
  }, [_c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Your Order")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content"
  }, [(_vm.cartItems.length > 0) ? _c('div', [_c('div', {
    staticClass: "cart-listing"
  }, _vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                                " + _vm._s(item.name) + " -\n                                " + _vm._s(item.description) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                                $" + _vm._s(item.price) + "\n                            ")])])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Subtotal:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartSubTotal)))])])]), _vm._v(" "), (_vm.cartTax > 0) ? _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Tax:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartTax)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Shipping:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.shipTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Total:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartTotal)))])])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content container"
  }, [(_vm.shippingFilledOut && !_vm.editingShipping) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("\n                        " + _vm._s(_vm.shippingAddress.first_name) + "\n                        " + _vm._s(_vm.shippingAddress.last_name) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.email) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.phone) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.address1) + "\n                        " + _vm._s(_vm.shippingAddress.address2) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.city) + ",\n                        " + _vm._s(_vm.shippingAddress.state) + "\n                        " + _vm._s(_vm.shippingAddress.zip) + "\n                        "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        _vm.editingShipping = true
      }
    }
  }, [_vm._v("Edit your information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('shipping-options')], 1)]) : _c('div', [_c('shipping-form', {
    on: {
      "saved": function($event) {
        _vm.editingShipping = false
      }
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingMethod !== false) ? _c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content"
  }, [(_vm.$store.state.payment.authorization === false) ? _c('div', [_c('div', {
    staticClass: "paypal-checkout"
  }, [_c('paypal', {
    attrs: {
      "currency": "USD",
      "dev": _vm.paypalDev,
      "amount": _vm.cartTotal,
      "create-payment": _vm.createPayment,
      "authorized-payment": _vm.authorizedPayment
    }
  })], 1)]) : _c('div', {
    staticClass: "is-5"
  }, [_c('strong', [_vm._v("\n                        You have authorized " + _vm._s(_vm._f("currency")(_vm.cartTotal)) + " to be transferred via PayPal.\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Click \"Finalize Order\" below to place your order and complete the transfer.\n                    "), _c('br'), _vm._v("\n                    You will receive an email confirmation of your order at the email address you supplied to\n                    PayPal.\n                ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.payment.authorization !== false) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button btn-important",
    on: {
      "click": function($event) {
        return _vm.executePayment()
      }
    }
  }, [_vm._v("Finalize Order")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-slider"
  }, [_c('div', {
    staticClass: "image-prev",
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('v-touch', {
    on: {
      "swipeleft": function($event) {
        return _vm.next()
      },
      "swiperight": function($event) {
        return _vm.prev()
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    style: ({
      'margin-left': _vm.currentOffset + 'px',
      'max-width': _vm.width + 'px'
    })
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "src": image
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "image-next",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'product-selector': true, 'select-active': _vm.selectedProduct !== null
    }
  }, _vm._l((_vm.reversedProducts), function(product) {
    return _c('div', {
      class: {
        'product-select': true, 'selected': _vm.selectedProduct === product.id
      },
      on: {
        "click": function($event) {
          _vm.selectedProduct === product.id ? _vm.selectProduct(null) : _vm.selectProduct(product.id)
        }
      }
    }, [_c('div', {
      staticClass: "product-description",
      domProps: {
        "innerHTML": _vm._s(product.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-image"
    }, [_c('img', {
      attrs: {
        "src": product.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-name"
    }, [_c('span', [_vm._v(_vm._s(product.short_name))])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "color-container"
  }, [_c('div', {
    class: {
      'color-display': true, 'select-active': _vm.selectedColor !== null
    }
  }, _vm._l((_vm.colors), function(color) {
    return _c('div', {
      class: {
        'color-option hoverable': true, 'selected': _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor === color ? _vm.selectColor(null) : _vm.selectColor(color)
        }
      }
    }, [_c('span', {
      staticClass: "color-name"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": color.img
      }
    })])
  }), 0), _vm._v(" "), (_vm.selectedColor !== null) ? _c('div', {
    staticClass: "color-description"
  }, [_c('h4', [_vm._v(_vm._s(_vm.selectedColor.full_name))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedColor.fabric.description)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true, 'has-errors': _vm.fieldErrors
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ninja-input"
  }, [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.handleInput],
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput,
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.fieldErrors) ? _c('ul', {
    staticClass: "form-errors"
  }, _vm._l((_vm.fieldErrors), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ninja-bars"
  }, [_c('div', {
    staticClass: "ninja-bar ninja-focus"
  }), _vm._v(" "), _c('div', {
    staticClass: "ninja-bar ninja-error"
  })])
}]}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true, 'has-errors': _vm.fieldErrors
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ninja-input"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled,
      "required": _vm.required
    },
    on: {
      "change": _vm.handleInput,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a state...")]), _vm._v(" "), _vm._l((_vm.options), function(option, key) {
    return _c('option', {
      domProps: {
        "value": key,
        "selected": _vm.checkSelected(key),
        "textContent": _vm._s(option)
      }
    })
  })], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.fieldErrors) ? _c('ul', {
    staticClass: "form-errors"
  }, _vm._l((_vm.fieldErrors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ninja-bars"
  }, [_c('div', {
    staticClass: "ninja-bar ninja-focus"
  }), _vm._v(" "), _c('div', {
    staticClass: "ninja-bar ninja-error"
  })])
}]}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cart-header"
  }, [_c('span', {
    staticClass: "cart-title"
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('a', {
    staticClass: "hide-cart",
    on: {
      "click": function($event) {
        return _vm.$emit('hideCart')
      }
    }
  }, [_vm._v("Hide Cart")])]), _vm._v(" "), (_vm.cartItems.length < 1) ? _c('div', {
    staticClass: "cart-empty"
  }, [_vm._v("Your cart is empty")]) : _c('div', {
    staticClass: "cart-listing"
  }, [_vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                " + _vm._s(item.name) + " -\n                " + _vm._s(item.description) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                $" + _vm._s(item.price) + "\n            ")])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm btn-primary add-to-cart-btn",
    on: {
      "click": function($event) {
        return _vm.goToReview()
      }
    }
  }, [_vm._v("Checkout")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'product-displayer': true, 'select-active': _vm.selectedProduct !== null
    }
  }, _vm._l((_vm.reversedProducts), function(product) {
    return _c('div', {
      class: {
        'product-display': true, 'selected': _vm.selectedProduct === product.id
      },
      on: {
        "click": function($event) {
          _vm.selectedProduct === product.id ? _vm.selectProduct(null) : _vm.selectProduct(product.id)
        }
      }
    }, [_c('div', {
      staticClass: "product-description",
      domProps: {
        "innerHTML": _vm._s(product.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-image"
    }, [_c('img', {
      attrs: {
        "src": product.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-name"
    }, [_c('span', [_vm._v(_vm._s(product.short_name))])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirmation"
  }, [_c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("Thank you for your order!")]), _vm._v(" "), _c('p', [_vm._v("\n        A confirmation email was sent to " + _vm._s(_vm.order.paypal_email) + ".\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "order-confirmation"
  }, [_c('h2', [_vm._v("Order #" + _vm._s(_vm.order.order_token))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("Billing")]), _vm._v("\n                    Payment method: PAYPAL\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.paypal_first_name) + " " + _vm._s(_vm.order.paypal_last_name) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.paypal_email) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("Shipping")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.order.shipping_provider) + " " + _vm._s(_vm.order.shipping_service) + " (~" + _vm._s(_vm.order.shipping_estimate + 5) + " days)")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.first_name) + " " + _vm._s(_vm.order.last_name) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.email) + "\n                    "), (_vm.order.phone !== null) ? _c('br') : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.order.phone) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.address1) + " " + _vm._s(_vm.order.address2) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.order.city) + ", " + _vm._s(_vm.order.state) + " " + _vm._s(_vm.order.zip) + "\n                ")])])]), _vm._v(" "), _c('h3', [_vm._v("Items")]), _vm._v(" "), _c('div', _vm._l((_vm.order.items), function(item) {
    return _c('div', [_vm._v("\n                " + _vm._s(item.item) + " -\n                " + _vm._s(item.color) + " -\n                " + _vm._s(_vm._f("currency")(item.price)) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "has-text-right"
  }, [_vm._v("\n            Subtotal: " + _vm._s(_vm._f("currency")(_vm.order.subtotal)) + "\n            "), _c('br'), _vm._v("\n            Shipping: " + _vm._s(_vm._f("currency")(_vm.order.shipping)) + "\n            "), _c('br'), _vm._v("\n            Tax: " + _vm._s(_vm._f("currency")(_vm.order.tax)) + "\n            "), _c('br'), _vm._v("\n            Total: " + _vm._s(_vm._f("currency")(_vm.order.total)) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paypal-button",
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shipping-options"
  }, [(_vm.loading) ? _c('div', [_c('strong', [_vm._v("Select a shipping method")]), _vm._v(" "), _c('br'), _vm._v("\n        Loading...\n        "), _c('loaders', {
    attrs: {
      "loader": "rolling"
    }
  })], 1) : _c('div', [(_vm.shippingMethod !== false) ? _c('div', [_c('strong', [_vm._v("Shipping Method")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "shipping-method"
  }, [(_vm.shippingMethod.provider === 'UPS') ? _c('img', {
    attrs: {
      "src": "/static/ups.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shippingMethod.provider === 'USPS') ? _c('img', {
    attrs: {
      "src": "/static/usps.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.shippingMethod.provider) + " " + _vm._s(_vm.shippingMethod.name) + "\n                    - " + _vm._s(_vm._f("currency")(_vm.shippingMethod.amount)) + "\n                    "), _c('br'), _vm._v("\n                    Delivery in "), _c('strong', [_vm._v(_vm._s(_vm.shippingMethod.estimate + 5) + " - " + _vm._s(_vm.shippingMethod.estimate + 7) + " days")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('em', [_vm._v("Delivery is an estimate based on manufacturing turnaround time.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        return _vm.clearOption()
      }
    }
  }, [_vm._v("Change Service")])]) : _c('div', [_c('strong', [_vm._v("Select a shipping method")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingMethods.length < 1) ? _c('div', [_vm._v("\n                Hmmm... The shipping methods couldn't be loaded.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        return _vm.loadMethods()
      }
    }
  }, [_vm._v("Retry")]), _vm._v(" "), _c('br')]) : _c('div', [_vm._l((_vm.sortedShippingMethods), function(method) {
    return _c('div', {
      staticClass: "shipping-option",
      on: {
        "click": function($event) {
          return _vm.setOption(method.token)
        }
      }
    }, [(method.provider === 'UPS') ? _c('img', {
      attrs: {
        "src": "/static/ups.svg"
      }
    }) : _vm._e(), _vm._v(" "), (method.provider === 'USPS') ? _c('img', {
      attrs: {
        "src": "/static/usps.svg"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(method.provider) + " " + _vm._s(method.name))]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(method.estimate) + " business days - " + _vm._s(_vm._f("currency")(method.amount)) + "\n                    ")])])
  }), _vm._v(" "), _vm._m(0)], 2)])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_vm._v("Depending on our available stock, please allow "), _c('strong', {
    staticStyle: {
      "color": "#D33"
    }
  }, [_vm._v("up to 5 extra business days")]), _vm._v(" for manufacturing lead time!")])
}]}

/***/ })
],[129]);


// WEBPACK FOOTER //
// static/js/app.ea04fe236b433a1e8189.js